import { Avatar, Box, Checkbox } from "@mui/material";
import styled from "@emotion/styled";
import theme from "../../../theme";
import { shouldForwardProp } from "../../../common/Common.style";

export const GroupHeaderWrapper = styled(Box)`
  display: flex;
  flex: 1;
  justify-content: space-between;
`;
type SearchBoxWrapperProps = {
  fullWidth: boolean;
};

export const SearchBoxWrapper = styled(Box, {
  shouldForwardProp: prop =>
    shouldForwardProp<SearchBoxWrapperProps>(["fullWidth"], prop),
})<SearchBoxWrapperProps>(({ fullWidth }) => ({
  display: "flex",
  justifyContent: "end",
  ...(fullWidth && {
    flex: 1,
    "& > *": {
      width: "100%",
      paddingBottom: 0,
    },
  }),
}));

export const MessageFilterWrapper = styled(Box)`
  margin-left: 8px;
  display: flex;
  align-items: center;
`;

export const SendersCounter = styled(Avatar)`
  margin: 0 1px 0 1px;
  font-size: 0.75rem;
  background-color: ${theme.palette.primary.main};
  width: 18px;
  height: 18px;
`;

export const SendersListWrapper = styled(Box)`
  display: flex;
  align-items: center;
  margin-right: 8px;
`;

export const SenderCheckbox = styled(Checkbox)`
  padding: 4px;
  margin-right: 4px;
`;

type ChatHeaderProp = {
  isLoading: boolean;
  onClick: () => void;
};

export const LoadingOverlay = styled(Box, {
  shouldForwardProp: prop =>
    shouldForwardProp<ChatHeaderProp>(["isLoading"], prop),
})<ChatHeaderProp>(({ isLoading }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1,
  cursor: "pointer",
  display: isLoading ? "block" : "none",
}));
